import saMessages from '../locales/pl_PL.json';

const saLang = {
  messages: {
    ...saMessages,
  },
  locale: 'he-IL',
};
export default saLang;
